import React from 'react'
import { useQRCode } from 'next-qrcode'
import Grid from '@mui/material/Grid'

import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'
const Generator = () => {
    const { Canvas } = useQRCode()
    const [value, setValue] = React.useState({ ssid: "", pass: "" })
    return (
        <Grid container style={{ display: "flex", justifyContent: "center", alignContent: "center", height: "100%" }}>
            <Paper elevation={8} style={{ textAlign: "center", padding: 16 }}>
                <Grid item xs={12}>
                    <TextField
                        id="SSID"
                        label="Network Name"
                        variant="outlined"
                        value={value.ssid}
                        onChange={e => setValue({ ssid: e.target.value, pass: value.pass })}
                        margin="normal"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="pass"
                        label="Password"
                        type="password"
                        variant="outlined"
                        value={value.pass}
                        onChange={e => setValue({ pass: e.target.value, ssid: value.ssid })}
                        margin="normal"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <Canvas
                        text={`WIFI:T:WPA;S:${value.ssid};P:${value.pass};;`}
                        options={{
                            type: 'image/jpeg',
                            quality: 0.3,
                            level: 'M',
                            margin: 3,
                            scale: 4,
                            width: 200,
                            color: {
                                dark: '#000',
                                light: '#FFF',
                            },
                        }} />
                </Grid>
            </Paper>
        </Grid>
    )
}

export default Generator